<template>
  <div class="ec-form-group">
    <label v-if="label" class="ec-form-label">
      {{ label }}
      <span v-if="required" class="ec-form-label__required">*</span>
    </label>
    <div
      class="ec-input"
      :class="{
        'ec-input--error': error,
        'ec-input--disabled': disabled,
        'ec-input--has-icon': icon,
      }"
    >
      <i v-if="icon" class="ec-input__icon bi" :class="'bi-' + icon" />
      <textarea
        v-if="type === 'textarea'"
        class="ec-input__field"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        :rows="rows"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event.target.value)"
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event)"
      />
      <input
        v-else
        class="ec-input__field"
        :type="type || 'text'"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event.target.value)"
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event)"
      />
    </div>
    <div v-if="error" class="ec-form-error">{{ error }}</div>
    <small v-if="hint && !error" class="ec-form-hint">{{ hint }}</small>
  </div>
</template>

<script>
export default {
  name: 'EcInput',

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: { type: [String, Number], default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    type: { type: String, default: 'text' },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: { type: String, default: '' },
    hint: { type: String, default: '' },
    icon: { type: String, default: '' },
    rows: { type: Number, default: 3 },
  },
}
</script>
